import React, { useContext, useEffect, useMemo, useState } from 'react';
import { MenuItem, Select, FormControl } from '@material-ui/core';
import { LanguageContext } from '../context/LanguageContext';
import { useStoreContext } from '../context/store';
import { useTranslation } from 'react-i18next';
import { AiOutlineTranslation } from 'react-icons/ai';
import { InputAdornment } from '@material-ui/core';
import styles from './style.module.scss';
import { get } from 'lodash';
import { showFlagByIp } from './constants';

const LanguageSelector = () => {
  const { language, setLanguage, supportedLanguages } =
    useContext(LanguageContext);
  const { instance } = useStoreContext();
  const { i18n } = useTranslation();
  const [flags, setFlags] = useState(undefined);

  const changeLanguage = (event) => {
    setLanguage(event.target.value.toLowerCase());
  };

  useEffect(() => {
    if (!language) return null;
    instance.changeLanguage(language);
    i18n.changeLanguage(language);
  }, [language, i18n]);

  useEffect(() => {
    (async () => {
      const countryEsp = await showFlagByIp();
      setFlags({
        en: {
          label: 'USA',
          src: 'https://flagcdn.com/w40/us.png',
          text: 'us',
        },
        es: {
          label: 'Spanish',
          src: `https://flagcdn.com/w40/${countryEsp}`,
          text: 'es',
        },
      });
    })();
  }, []);

  if (!flags) return null;

  return (
    <FormControl
      variant="outlined"
      style={{
        position: 'fixed',
        top: 10,
        right: 30,
        zIndex: 1000,
        minWidth: '100px',
        background: '#fff',
        borderRadius: '9px',
      }}
    >
      <Select
        startAdornment={
          <InputAdornment position="start">
            <AiOutlineTranslation size={18} />
          </InputAdornment>
        }
        labelId="language-select-label"
        value={language ? language : 'es'}
        onChange={changeLanguage}
      >
        {supportedLanguages &&
          supportedLanguages.map((lang) => (
            <MenuItem key={lang} value={lang}>
              <img
                className={styles['flag-icon']}
                src={get(flags, `${lang}.src`)}
                alt={lang}
                width={40}
              />
              {lang.toUpperCase()}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelector;
